var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailHardBounce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81607 0.318526C1.40062 -0.106175 0.72704 -0.106175 0.311589 0.318526C-0.103863 0.743228 -0.103863 1.43181 0.311589 1.85651L9.79793 11.5541C10.3796 12.1486 11.3226 12.1486 11.9042 11.5541L17.8723 5.45304V7.17761C17.8723 7.77823 18.3486 8.26513 18.9362 8.26513C19.5237 8.26513 20 7.77823 20 7.17761V3.26255C20 2.42168 19.3332 1.74003 18.5106 1.74003H14.6809C14.0933 1.74003 13.617 2.22692 13.617 2.82754C13.617 3.42816 14.0933 3.91506 14.6809 3.91506H16.3679L10.8511 9.55469L1.81607 0.318526Z",
    fill: "#FBBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailHardBounce);
export default __webpack_public_path__ + "static/media/mail-hard-bounce.ebcae3ef142e2217c20f7d26b9f1d092.svg";
export { ForwardRef as ReactComponent };